export const environment = {
  production: true,
  applicationServerPublicKey: 'BIwsbz5HtZMRUuK6KHax49l0jOITSxVhEzXs11IubBBpza7dQ59qDvV3e6UqOE7O4hW-Mj8zG-XdIK5EskcH-Wc'
};
